import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import Time from '../../Time';
import PayrollScreenShots from './PayrollScreenShots';
import '../../css/App.css'
import '../../css/bootstrap.min.css';
import bootstrap from 'bootstrap'
import AlertWindow from '../../Alert';
const axios = require('axios').default;

class PayrollRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hrStartTimeDate:"",
      hrEndTimeDate:"",
      totalHrHours:"",
      difference:"",
      seeScreenshots:false,
      differenceColorLetter:"",
      approveButtonText:"Approve",
      screenshotClicked:false,
      alertWindow:""
    };

    this.handleChange = this.handleChange.bind(this)
    this.getScreenshots = this.getScreenshots.bind(this)
    this.calculateHoursWorked = this.calculateHoursWorked.bind(this)
    this.closeAlert = this.closeAlert.bind(this)

    this.hrStartTimeForm = React.createRef();
    this.hrEndTimeForm = React.createRef(); 
  }


  //Opens and closes the Screenshot window
  getScreenshots = () =>{
    let windowScreenShots = this.state.seeScreenshots;      
    this.setState({seeScreenshots:!windowScreenShots})
    this.setState({screenshotClicked:true})
  }

  //Closes the alert Window
  closeAlert = () =>{
    this.setState({alertWindow:""})
  }
  componentDidMount = () =>{
    const originalStartHours = new Date(this.props.OriginalStartTime) 
    const originalEndtHours = new Date(this.props.OriginalEndTime)
    const editedStartHours = new Date(this.props.StartTime)
    const editedEndHours = new Date(this.props.EndTime)

    //Calculate the difference between the original and the user ajustment
    const originalResult = originalEndtHours/1000 - originalStartHours/1000;
    const editedResult = editedEndHours/1000 - editedStartHours/1000;

    let calculated = editedResult - originalResult
    //console.log(calculated)
    
    let finalResult;
    if(isNaN(calculated)){
      finalResult = "Shift not finished";
    }else if(calculated < 0){
      calculated = calculated * -1
      finalResult = "-"+Time.convertSecondsToString(calculated);
      finalResult = finalResult.slice(0,6)
    }else{
      finalResult = Time.convertSecondsToString(calculated);
      finalResult = finalResult.slice(0,5)
      
    }
    //If result is negative it means the worker is losing hours after the ajustment
    //if it is positive it means the worker is getting hours
    this.setState({difference:finalResult})

    //We also check if HR has approved this shift before, in that case we already fill the data for the
    //HR person
    if(this.props.HREndTime !="0000-00-00 00:00:00" && this.props.HREndTime !="0001-01-01 00:00:00"){
      this.setState({approveButtonText:"Approved"})
    }else{
      this.setState({approveButtonText:"Approve"})
    }
    this.calculateHoursWorked()
  }
  calculateHoursWorked = () =>{
    //Calculate the total of hours worked
    let totalHours;
    let startHR = new Date(this.hrStartTimeForm.current.value);
    let endHR = new Date(this.hrEndTimeForm.current.value);
    if(startHR > endHR){
      totalHours = "Invalid: End time cannot be before start time";
    }else if(isNaN(endHR/1000 - startHR/1000)){
      totalHours = "Shift not ended";
    }else{
      totalHours = Time.convertSecondsToString(endHR/1000 - startHR/1000)
    }
    this.setState({totalHrHours:totalHours})
  }

  handleChange = (e) =>{
    
    this.setState({[e.target.id]: e.target.value});
    this.calculateHoursWorked();

    if(this.state.approveButtonText == 'Approved'){
      this.setState({approveButtonText:'Update'})
    }

  }

  //When you click the button approve you activate this
  approveShift = async()=>{

    //Checks if user clicked see screenshots buttons
    //also checks if this is really necessary
    if(!this.state.screenshotClicked && this.props.WorkLocation != "Vacation" && this.props.WorkLocation != "Holiday"){
      this.setState({alertWindow:"You need to check the screenshots before approving this shift"})
      return;
    }
   
    var formdata = new FormData();
    formdata.append("shiftId", this.props.Id);
    formdata.append("HrStartTime", this.hrStartTimeForm.current.value);
    formdata.append("HrEndTime", this.hrEndTimeForm.current.value);

    console.log(this.props.Id)

    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    fetch("https://dashboard.realsexdoll.info/php/payroll/approveshift.php", requestOptions)
    .then(response => response.text())
    .then(result => console.log(result))
    .catch(error => console.log('error', error));

    this.setState({approveButtonText:"Approved"})

  }
  render() {

    //Alert Configs
    let alertWindowHTML;
    if(this.state.alertWindow !=""){
      alertWindowHTML = 
      <AlertWindow 
        title="I am sorry" 
        message={this.state.alertWindow}
        close={this.closeAlert}
      />
    }

    //Checks if HR already approved this shift and changes the date
    let HRStartTime;
    let HREndTime;
    if(this.props.HREndTime !="0000-00-00 00:00:00" && this.props.HREndTime !="0001-01-01 00:00:00"){
      HRStartTime = this.props.HRStartTime;
      HREndTime = this.props.HREndTime;
    }else{
      HRStartTime = this.props.StartTime;
      HREndTime = this.props.EndTime;
    }

    //Give Conditions to show the Screenshot window to the user
    let screenShotWindow;
    if(this.state.seeScreenshots){
      screenShotWindow = 
      <PayrollScreenShots
        id={this.props.Id}
        close={this.getScreenshots}
      />
    }

    //Give conditions for the Show screenshot button to appear or not
    //It means it need to be different from Vacation and Holiday
    let showScreenshotsBtn;
    if(this.props.WorkLocation != "Vacation" && this.props.WorkLocation != "Holiday"){
      showScreenshotsBtn = <button onClick={this.getScreenshots}>See Screenshots</button>;
    }

    //if Difference is positive show red letters
    let conditionLetter = "";
    if(this.state.difference[0] != "-" && this.state.difference != "00:00"){
      conditionLetter = "red-letters"
    }

    //Unpaied Breaks only after 30 minutes
    let unpaiedBreaks = this.props.BreakMinutes - 30;
      if(unpaiedBreaks < 0){
        unpaiedBreaks = 0
      }

    //Instead of 1 or 0 it shows yes or no in case 
    //the user requested some changes on the shift
    let requestStatus = this.props.UserFlagged;
    if(requestStatus == "1"){
      requestStatus = "Yes";
    }else{
      requestStatus = "No";
    }

    return(
      <tr>
        <td>{this.props.Id}</td>
        <td>{this.props.Username}</td>
        <td>{Time.convertToAMnPM( new Date(this.props.OriginalStartTime) )}</td>
        <td>{Time.convertToAMnPM( new Date(this.props.OriginalEndTime) )}</td>
        <td>{Time.convertToAMnPM( new Date(this.props.StartTime) )}</td>
        <td>{Time.convertToAMnPM( new Date(this.props.EndTime) )}</td>
        <td>{unpaiedBreaks}</td>
        <td>{requestStatus}</td>
        <td>{this.props.FlagReason}</td>
        <td className={conditionLetter}>{this.state.difference}</td>
        <td><input onChange={this.handleChange} ref={this.hrStartTimeForm} defaultValue={HRStartTime} id='hrStartTimeDate' type="datetime-local"></input></td>
        <td><input onChange={this.handleChange} ref={this.hrEndTimeForm} defaultValue={HREndTime} id='hrEndTimeDate' type="datetime-local"></input></td>
        <td><button onClick={this.approveShift}>{this.state.approveButtonText}</button></td>
        <td>{this.props.WorkLocation}</td>
        <td>{this.state.totalHrHours}</td>
        <td>{showScreenshotsBtn}</td>
        {screenShotWindow}
        {alertWindowHTML}
      </tr>
    );
  }
}

export default PayrollRow;